<template>
  <b-card v-if="enable" :sub-title="title">
    {{ label }}
    <b-select
      v-model="selectedOption"
      v-b-tooltip.hover="tooltipTitle"
      :disabled="filterByLocationActive || !(singleCategoryOptions.length > 1)"
      :options="singleCategoryOptions"
      @change="onOptionSelected"
    />
  </b-card>
</template>

<script lang="ts">
import Component from 'vue-class-component'

import FilterByCategoryMixin from '@/mixins/FilterByCategoryMixin'

@Component
export default class FilterBubblesUI extends FilterByCategoryMixin {
  selectedOption: string | null = null

  get enable() {
    return this.filterByCategoryConfig.enable && this.isSingleCategory
  }

  get isSingleCategory() {
    return this.columns?.length === 1
  }

  get singleCategory() {
    return (this.columns && this.columns[0]) || ''
  }

  get singleCategoryOptions() {
    return this.isSingleCategory ? this.optionsForCategory(this.singleCategory) : []
  }

  get tooltipTitle() {
    return this.filterByLocationActive
      ? 'Cannot filter by category when search by location is active'
      : ''
  }

  onOptionSelected(value: string | null) {
    if (value === null) {
      this.filterStore.clearAll()
    } else {
      this.filterStore.deselectAll(this.singleCategory)
      this.filterStore.update(this.singleCategory, value, true)
    }
  }
}
</script>
